import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { validateToken, getVideoById, getTrainingVideos } from "../../services/AuthService"
import "./VideoDetail.css";
import NavbarCapacita from "../../components/NavbarCapacita/NavbarCapacita";
import Footer from "../../components/footer/Footer";
import { CircularProgress } from "@mui/material";
import ReactPlayer from "react-player";

const VideoDetail = () => {
    const { id } = useParams();
    const [video, setVideo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Estado para modo móvil

    const [videoNumber, setVideoNumber] = useState(null);
    const [allVideos, setAllVideos] = useState([]);

    const [prevVideo, setPrevVideo] = useState(null);
    const [nextVideo, setNextVideo] = useState(null);

    const getEmbedUrl = (url) => {
        let videoId = "";
        if (url.includes("youtu.be/")) {
            videoId = url.split("youtu.be/")[1]?.split("?")[0];
        } else if (url.includes("youtube.com/watch?v=")) {
            videoId = url.split("v=")[1]?.split("&")[0];
        }
        return videoId ? `https://www.youtube.com/embed/${videoId}` : "";
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        setLoading(true);
        getVideoById(id)
            .then(response => {
                setVideo(response.data.content);
            })
            .catch(error => {
                console.error("Error fetching video details:", error);
                setError(error);
                setLoading(false);
            });
    }, [id]);

    const fetchAdjacentVideos = () => {
        getTrainingVideos()
            .then(response => {
                setLoading(false);
                const videos = Array.isArray(response.data.content) ? response.data.content : [];
                setAllVideos(videos);

                if (video) {
                    const currentIndex = videos.findIndex(v => v.id.toString() === id);
                    if (currentIndex !== -1) {
                        setVideoNumber(currentIndex + 1);
                        setPrevVideo(currentIndex > 0 ? videos[currentIndex - 1] : null);
                        setNextVideo(currentIndex < videos.length - 1 ? videos[currentIndex + 1] : null);
                    }
                }
            })
            .catch(error => {
                setLoading(false);
                setError(error);
                console.error("Error fetching videos:", error)
            });
    };

    useEffect(() => {
        if (video) {
            fetchAdjacentVideos();
        }
    }, [video, id]);

    if (loading) return (
        <div className="video-detail-container">
            <NavbarCapacita />
            <div className="loading-container">
                <CircularProgress />
            </div>
            <Footer />
        </div>
    );

    if (error) return (
        <div className="video-detail-container">
            <NavbarCapacita />
            <div className="error-container">
                <p className="error-message">Error: {error.message}</p>
            </div>
            <Footer />
        </div>
    );

    if (!video) return (
        <div className="video-detail-container">
            <NavbarCapacita />
            <div className="not-found-container">
                <p className="not-found-message">Video not found.</p>
            </div>
            <Footer />
        </div>
    );

    return (
        <div className="video-detail-container">
            <NavbarCapacita />
            <div className="video-detail-content">
                <h1>{videoNumber !== null ? `${videoNumber}. ${video.title}` : video.title}</h1>
                <div className="video-info">                    
                    <div className="video-description">
                        <p>{video.description}</p>
                        {/* Muestra la navegación original en pantallas grandes */}
                        {!isMobile && (
                            <div className="video-navigation">
                                <div className="prev-video">
                                    {prevVideo && (
                                        <Link to={`/video/${prevVideo.id}`}>                                            
                                            <p>VIDEO ANTERIOR</p>
                                            <h4>{videoNumber !== null ? `${videoNumber - 1}. ${prevVideo.title}` : prevVideo.title}</h4>
                                        </Link>
                                    )}
                                </div>
                                <div className="next-video">
                                    {nextVideo && (
                                        <Link to={`/video/${nextVideo.id}`}>
                                            <p>SIGUIENTE VIDEO</p>
                                            <h4>{videoNumber !== null ? `${videoNumber + 1}.  ${nextVideo.title}` : nextVideo.title}</h4>
                                        </Link>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="video-iframe-container">
                        <ReactPlayer url={video.url} controls={true} width='100%' height='100%' />
                        
                    </div>
                </div>
                {/* Mueve la navegación fuera de video-info en responsive */}
                {isMobile && (
                    <div className="video-navigation-mobile">
                        <div className="prev-video">
                            {prevVideo && (
                                <Link to={`/video/${prevVideo.id}`}>
                                    <p>VIDEO ANTERIOR</p>
                                    <h4>{videoNumber !== null ? `${videoNumber - 1}. ${prevVideo.title}` : prevVideo.title}</h4>
                                </Link>
                            )}
                        </div>
                        <div className="next-video">
                            {nextVideo && (
                                <Link to={`/video/${nextVideo.id}`}>
                                    <p>SIGUIENTE VIDEO</p>
                                    <h4>{videoNumber !== null ? `${videoNumber + 1}.  ${nextVideo.title}` : nextVideo.title}</h4>
                                </Link>
                            )}
                        </div>
                    </div>
                )}
            </div>
            <Footer />
        </div>
    );
};

export default VideoDetail;